module.exports = __webpack_public_path__ + "images/night.076354bc31e6cc6ba29a04f149871820.png";